import React, {
  Fragment,
  useState,
  useEffect
} from "react";

import axios from "axios";
import swal from "sweetalert";


const Checkout = () => {


  /*
  |--------------------------------------------------------------------------
  | CAPTCHA API
  |--------------------------------------------------------------------------
  */

  const CAPTCHA_CREATE_API =
    "https://backoffice.segma.app/api/captcha/create";


  /*
  |--------------------------------------------------------------------------
  | USER
  |--------------------------------------------------------------------------
  */

  const [user, setUser] =
    useState([]);


  useEffect(() => {

    const auth_token =
      localStorage.getItem(
        "auth_token"
      );

    const selectedCurrency =
      localStorage.getItem(
        "selectedCurrency"
      );


    const data = {

      key_s:
        "eyJ0eXAiOiJKV1Qidfg%!#%$%LCdf#*&*JhbGciOiJSUzI1NiJ9",

      currency:
        selectedCurrency,

    };


    if (
      auth_token !== null
    ) {

      axios
        .post(
          "/apps-profile",
          data
        )
        .then(response => {

          setUser(
            response.data
          );

          console.log(
            response.data
          );

        })
        .catch(error => {

          console.log(
            error
          );

        });

    }

  }, []);


  /*
  |--------------------------------------------------------------------------
  | BALANCE
  |--------------------------------------------------------------------------
  */

  let reserve_balance;


  if (
    user == ""
  ) {

    console.log(
      user
    );

  }

  else {

    reserve_balance =
      user.data.reserve_balance;

  }


  /*
  |--------------------------------------------------------------------------
  | TRANSFER INPUT
  |--------------------------------------------------------------------------
  */

  const [
    depositInput,
    setDepositInput
  ] = useState({

    username: "",

    amount: "",

    password: "",

    error_list: [],

  });


  /*
  |--------------------------------------------------------------------------
  | NORMAL INPUT
  |--------------------------------------------------------------------------
  */

  const handleInput = (e) => {

    e.persist();


    setDepositInput({

      ...depositInput,

      [e.target.name]:
        e.target.value

    });

  };


  /*
  |--------------------------------------------------------------------------
  | LOADING
  |--------------------------------------------------------------------------
  */

  const [
    loading,
    setLoading
  ] = useState(false);


  /*
  |--------------------------------------------------------------------------
  | CAPTCHA STATES
  |--------------------------------------------------------------------------
  */

  const [
    captchaId,
    setCaptchaId
  ] = useState("");


  const [
    captchaImage,
    setCaptchaImage
  ] = useState("");


  const [
    captchaText,
    setCaptchaText
  ] = useState("");


  const [
    captchaLoading,
    setCaptchaLoading
  ] = useState(false);


  const [
    captchaError,
    setCaptchaError
  ] = useState("");


  /*
  |--------------------------------------------------------------------------
  | LOAD CAPTCHA
  |--------------------------------------------------------------------------
  */

  const loadCaptcha =
    async () => {

      if (
        captchaLoading
      ) {

        return;

      }


      setCaptchaLoading(true);

      setCaptchaId("");

      setCaptchaImage("");

      setCaptchaText("");

      setCaptchaError("");


      try {

        const response =
          await axios.get(
            CAPTCHA_CREATE_API,
            {

              headers: {

                Accept:
                  "application/json"

              }

            }
          );


        if (
          response.data &&
          response.data.status ===
            "success" &&
          response.data.captcha_id &&
          response.data.captcha_image
        ) {

          setCaptchaId(
            response.data
              .captcha_id
          );


          setCaptchaImage(
            response.data
              .captcha_image
          );

        }

        else {

          setCaptchaError(
            response.data &&
            response.data.message
              ? response.data.message
              : "Unable to load CAPTCHA."
          );

        }

      }

      catch (error) {

        setCaptchaError(
          error.response &&
          error.response.data &&
          error.response.data.message
            ? error.response
                .data
                .message
            : "Unable to load CAPTCHA."
        );

      }

      finally {

        setCaptchaLoading(false);

      }

    };


  /*
  |--------------------------------------------------------------------------
  | LOAD CAPTCHA ON PAGE OPEN
  |--------------------------------------------------------------------------
  */

  useEffect(() => {

    loadCaptcha();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  /*
  |--------------------------------------------------------------------------
  | CAPTCHA INPUT
  |--------------------------------------------------------------------------
  */

  const handleCaptchaInput =
    (e) => {

      const value =
        e.target.value
          .replace(
            /\s/g,
            ""
          )
          .toUpperCase()
          .slice(
            0,
            10
          );


      setCaptchaText(
        value
      );


      setCaptchaError("");

    };


  /*
  |--------------------------------------------------------------------------
  | TRANSFER SUBMIT
  |--------------------------------------------------------------------------
  */

  const depositSubmit =
    async (e) => {

      e.preventDefault();


      const auth_token =
        localStorage.getItem(
          "auth_token"
        );


      /*
      |--------------------------------------------------------------------------
      | CAPTCHA CHECK
      |--------------------------------------------------------------------------
      */

      if (
        !captchaId
      ) {

        swal(
          "Warning",
          "CAPTCHA is not loaded. Please refresh CAPTCHA.",
          "warning"
        );


        return;

      }


      if (
        !captchaText.trim()
      ) {

        swal(
          "Warning",
          "Please enter CAPTCHA code.",
          "warning"
        );


        return;

      }


      /*
      |--------------------------------------------------------------------------
      | DATA
      |--------------------------------------------------------------------------
      */

      const data = {

        username:
          depositInput.username,

        amount:
          depositInput.amount,

        password:
          depositInput.password,


        /*
        |--------------------------------------------------------------------------
        | CAPTCHA
        |--------------------------------------------------------------------------
        */

        captcha_id:
          captchaId,

        captcha_text:
          captchaText.trim(),


        key_s:
          "eyJ0eXAiOiJKV1Qidfg%!#%$%LCdf#*&*JhbGciOiJSUzI1NiJ9"

      };


      if (
        auth_token !== null &&
        !loading
      ) {

        setLoading(true);


        try {

          const res =
            await axios.post(
              "/transfer-balance",
              data
            );


          setLoading(false);


          /*
          |--------------------------------------------------------------------------
          | SUCCESS
          |--------------------------------------------------------------------------
          */

          if (
            res.data.status ===
              "success"
          ) {

            swal(
              "Success",
              res.data.message,
              "success"
            );


            setDepositInput({

              ...depositInput,

              username: "",

              amount: "",

              password: "",

            });


            /*
            |--------------------------------------------------------------------------
            | NEW CAPTCHA
            |--------------------------------------------------------------------------
            */

            await loadCaptcha();

          }


          /*
          |--------------------------------------------------------------------------
          | FAIL
          |--------------------------------------------------------------------------
          */

          else if (
            res.data.status ===
              "fail"
          ) {

            swal(
              "Warning",
              res.data.message,
              "warning"
            );


            /*
            |--------------------------------------------------------------------------
            | CAPTCHA IS ONE-TIME
            |--------------------------------------------------------------------------
            */

            await loadCaptcha();

          }


          /*
          |--------------------------------------------------------------------------
          | VALIDATION ERROR
          |--------------------------------------------------------------------------
          */

          else {

            setDepositInput({

              ...depositInput,

              error_list:
                res.data
                  .validation_error

            });


            await loadCaptcha();

          }

        }

        catch (error) {

          setLoading(false);


          /*
          |--------------------------------------------------------------------------
          | 422
          |--------------------------------------------------------------------------
          */

          if (
            error.response &&
            error.response.status ===
              422
          ) {

            setDepositInput({

              ...depositInput,

              error_list:
                error.response
                  .data
                  .validation_error ||
                error.response
                  .data
                  .errors ||
                []

            });

          }


          /*
          |--------------------------------------------------------------------------
          | 429
          |--------------------------------------------------------------------------
          */

          else if (
            error.response &&
            error.response.status ===
              429
          ) {

            swal(
              "Warning",
              "Too many attempts. Please wait and try again.",
              "warning"
            );

          }


          /*
          |--------------------------------------------------------------------------
          | OTHER ERROR
          |--------------------------------------------------------------------------
          */

          else {

            swal(
              "Error",
              error.response &&
              error.response.data &&
              error.response.data.message
                ? error.response
                    .data
                    .message
                : "Transfer failed. Please try again.",
              "error"
            );

          }


          await loadCaptcha();

        }

      }

    };


  /*
  |--------------------------------------------------------------------------
  | VIEW
  |--------------------------------------------------------------------------
  */

  return (

    <Fragment>


      <div
        className="
          d-flex
          justify-content-center
          align-items-center
          min-vh-100
          bg-light
        "
      >


        <div
          className="
            col-md-10
            col-lg-8
            mt-3
          "
        >


          <div
            className="
              card
              shadow-lg
              p-4
              rounded-4
              border-0
            "
          >


            <div className="card-body">


              <h2
                className="
                  text-center
                  text-success
                  mb-4
                "
              >

                Transfer Funds Securely

              </h2>


              <p
                className="
                  text-center
                  text-muted
                "
              >

                Send balance to another
                user easily and safely.

              </p>


              {/* =====================================================
                  BALANCE
              ===================================================== */}

              <button
                type="button"
                className="
                  btn
                  btn-lg
                  w-100
                  text-white
                  d-flex
                  align-items-center
                  justify-content-center
                  gap-2
                  shadow
                  mb-3
                "
                style={{

                  background:
                    "#002f6a",

                  borderRadius:
                    "14px",

                  transition:
                    "0.3s",

                }}
              >

                <i
                  className="
                    fa
                    fa-wallet
                    fs-4
                  "
                >
                </i>


                <span
                  className="
                    fs-3
                    fw-bold
                  "
                >

                  Balance: $

                  {
                    Number(
                      reserve_balance
                    ).toFixed(2)
                  }

                </span>

              </button>


              {/* =====================================================
                  FORM
              ===================================================== */}

              <form
                onSubmit={
                  depositSubmit
                }
              >


                {/* USERNAME */}

                <div className="mb-3">

                  <label
                    className="form-label"
                  >

                    Recipient Username

                  </label>


                  <input
                    type="text"
                    className="form-control"
                    name="username"
                    placeholder="Enter recipient's username"
                    onChange={
                      handleInput
                    }
                    value={
                      depositInput.username
                    }
                    required
                  />


                  <small
                    className="text-danger"
                  >

                    {
                      depositInput
                        .error_list
                        .username
                    }

                  </small>

                </div>


                {/* AMOUNT */}

                <div className="mb-3">

                  <label
                    className="form-label"
                  >

                    Transfer Amount ($)

                  </label>


                  <input
                    type="text"
                    className="form-control"
                    name="amount"
                    placeholder="Enter amount to transfer"
                    onChange={
                      handleInput
                    }
                    value={
                      depositInput.amount
                    }
                    required
                  />


                  <small
                    className="text-danger"
                  >

                    {
                      depositInput
                        .error_list
                        .amount
                    }

                  </small>

                </div>


                {/* PASSWORD */}

                <div className="mb-3">

                  <label
                    className="form-label"
                  >

                    Your Account Password

                  </label>


                  <input
                    type="password"
                    className="form-control"
                    name="password"
                    placeholder="Confirm your password"
                    onChange={
                      handleInput
                    }
                    value={
                      depositInput.password
                    }
                    required
                  />


                  <small
                    className="text-danger"
                  >

                    {
                      depositInput
                        .error_list
                        .password
                    }

                  </small>

                </div>


                {/* =====================================================
                    CAPTCHA
                ===================================================== */}

                <div className="mb-3">


                  <label
                    className="
                      form-label
                      fw-bold
                    "
                  >

                    Security CAPTCHA

                  </label>


                  <div
                    className="
                      d-flex
                      gap-2
                      mb-2
                    "
                  >


                    {/* CAPTCHA IMAGE */}

                    <div
                      className="
                        border
                        rounded
                        bg-white
                        d-flex
                        align-items-center
                        justify-content-center
                      "
                      style={{

                        minHeight:
                          "80px",

                        flex:
                          "1",

                        overflow:
                          "hidden"

                      }}
                    >

                      {
                        captchaLoading
                          ? (

                            <span
                              className="
                                text-muted
                                small
                              "
                            >

                              <i
                                className="
                                  fa
                                  fa-spinner
                                  fa-spin
                                "
                              />

                              {" "}

                              Loading CAPTCHA...

                            </span>

                          )

                          : captchaImage
                          ? (

                            <img
                              src={
                                captchaImage
                              }
                              alt="Security CAPTCHA"
                              style={{

                                maxWidth:
                                  "100%",

                                maxHeight:
                                  "75px",

                                objectFit:
                                  "contain"

                              }}
                            />

                          )

                          : (

                            <span
                              className="
                                text-muted
                                small
                              "
                            >

                              CAPTCHA unavailable

                            </span>

                          )
                      }

                    </div>


                    {/* REFRESH */}

                    <button
                      type="button"
                      className="
                        btn
                        btn-primary
                      "
                      onClick={
                        loadCaptcha
                      }
                      disabled={
                        captchaLoading ||
                        loading
                      }
                    >

                      {
                        captchaLoading
                          ? (
                            <i
                              className="
                                fa
                                fa-spinner
                                fa-spin
                              "
                            />
                          )
                          : (
                            <>
                              <i
                                className="
                                  fa
                                  fa-refresh
                                "
                              />

                              {" "}

                              Refresh
                            </>
                          )
                      }

                    </button>

                  </div>


                  {/* CAPTCHA INPUT */}

                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter CAPTCHA code"
                    value={
                      captchaText
                    }
                    onChange={
                      handleCaptchaInput
                    }
                    maxLength="10"
                    autoComplete="off"
                    spellCheck="false"
                    disabled={
                      captchaLoading ||
                      !captchaId ||
                      loading
                    }
                    required
                  />


                  {
                    captchaError && (

                      <small
                        className="
                          text-danger
                          d-block
                          mt-1
                        "
                      >

                        {
                          captchaError
                        }

                      </small>

                    )
                  }


                  <small
                    className="
                      text-muted
                      d-block
                      mt-1
                    "
                  >

                    CAPTCHA will be verified
                    by the server when you
                    submit the transfer.

                  </small>

                </div>


                {/* =====================================================
                    TERMS
                ===================================================== */}

                <div
                  className="
                    form-check
                    my-3
                  "
                >

                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="termsCheck"
                    required
                  />


                  <label
                    className="form-check-label"
                    htmlFor="termsCheck"
                  >

                    I agree to the{" "}

                    <span
                      className="text-primary"
                    >

                      terms and conditions

                    </span>.

                  </label>

                </div>


                {/* =====================================================
                    SUBMIT
                ===================================================== */}

                <div className="d-grid">

                  <button
                    type="submit"
                    className="
                      btn
                      btn-success
                      btn-lg
                    "
                    disabled={
                      loading ||
                      captchaLoading ||
                      !captchaId ||
                      !captchaText.trim()
                    }
                  >

                    {
                      loading
                        ? "Processing..."
                        : "Send Balance"
                    }

                  </button>

                </div>

              </form>


              {/* =====================================================
                  YOUR OLD TRANSFER SUMMARY
              ===================================================== */}

              {/*
              <div className="mt-5">

                <h5 className="text-center text-muted">
                  Transfer Summary
                </h5>

                <div className="list-group list-group-flush">

                  <div className="list-group-item d-flex justify-content-between">
                    <span>Recipient</span>

                    <strong>
                      {
                        depositInput.username ||
                        "N/A"
                      }
                    </strong>
                  </div>

                  <div className="list-group-item d-flex justify-content-between">
                    <span>Amount</span>

                    <strong>
                      $
                      {
                        depositInput.amount ||
                        "0.00"
                      }
                    </strong>
                  </div>

                  <div className="list-group-item d-flex justify-content-between">
                    <span>Status</span>

                    <strong className="text-warning">
                      Pending
                    </strong>
                  </div>

                </div>

              </div>
              */}

            </div>

          </div>

        </div>

      </div>

    </Fragment>
  );

};


export default Checkout;